// import { combineReducers } from 'redux';
import {combineReducers } from '@reduxjs/toolkit';
import { reducer as formReducer } from 'redux-form';
import auth from './auth';
import permissions from './permissions';

// this file combine the different reducer of the app.
export default combineReducers({
  auth,
  permissions,
  form: formReducer
});
